import { PDPModal } from '@hungryroot/rdp';
import { usePdpFooter } from '../../PDP/usePdpFooter';

interface SearchResultPDPProps {
  productId: number;
  onModalClose: () => void;
  onAddClick: () => void;
  onRemoveClick: () => void;
}

export function SearchResultPDP({
  productId,
  onModalClose,
}: SearchResultPDPProps) {
  const { createFooterButton } = usePdpFooter({
    onAdd: onModalClose,
    onRemove: onModalClose,
  });

  return (
    <PDPModal
      id={productId}
      testid="search-result-pdp"
      onDismiss={onModalClose}
      stacked={false}
      createFooterButton={createFooterButton}
      showOSNSection={true}
    />
  );
}
